import { z } from 'zod';
import { errorSchema } from './error-schema';

export const messageSchema = z.object({
  message: z.string().nullable(),
  error: errorSchema.optional(),
});
